import axios from 'axios';

const state= {
    property : [],
    Items:[]
};

const getters = {
    Items: state => state.Items,
};

const actions = {
    async saveServiveCategory({commit}, params){
      return new Promise (( resolve, reject ) => {
          global.axios(`api/contracts/${params.contract_id}/service-categories`, {
              method: "POST",
              data:  params,
              headers: {
                Accept: "application/json",
              }
          })
          .then(response => {
            resolve( response );
          })
          .catch(error => reject( error ));
      });
  },
    async saveCheckedServiveCategory({commit}, params){
    return new Promise (( resolve, reject ) => {
        global.axios(`api/s-contracts/service-categories`, {
            method: "POST",
            data:  params,
            headers: {
              Accept: "application/json",
            }
        })
        .then(response => {
          resolve( response );
        })
        .catch(error => reject( error ));
    });
    },
    async updateServiveCategory({commit}, params){
    return new Promise (( resolve, reject ) => {
        global.axios(`api/contracts/${params.contract_id}/service-categories/${params.id}`, {
            method: "PUT",
            data:  params,
            headers: {
              Accept: "application/json",
            }
        })
        .then(response => {
          resolve( response );
        })
        .catch(error => reject( error ));
    });
    },
    async removeServiveCategory({commit}, params){
    return new Promise (( resolve, reject ) => {
        global.axios(`api/contracts/${params.contract_id}/service-categories/${params.id}`, {
            method: "DELETE",
            headers: {
              Accept: "application/json",
            }
        })
        .then(response => {
          resolve( response );
        })
        .catch(error => reject( error ));
    });
    },
    async uploadFileServiceCategory({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('file_import',params.fileServiceCategory);
            if(params.is_master){
                formData.append('is_master',params.is_master);
            }
            global.axios.post(`api/contracts/${params.contract_id}/service-categories/import`,formData,
            {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {

              resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async exportServiceCategory({ commit }, contract_id) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/contracts/${contract_id}/service-categories/export`, {
                responseType: 'blob'
            })
            .then(response => {
                console.log(response)
                resolve(response);
            })
            .catch(error => reject(error));
        });
    },
    async getAllServiceCategory({commit}, params){
        return new Promise (( resolve, reject ) => {

            global.axios(`api/contracts/${params}/all-service-categories`, {
                method: "GET",
                headers: {
                  Accept: "application/json",
                }
            })
            .then(response => {
              resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    getServiceCategories({commit}, params){
        return new Promise((resolve, reject) => {
            global.axios.get(`api/contracts/${params.contractId}/tree-service-categories/${params.categoryId}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    getMaster({commit}, params){
        let id = params.id;
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/master/tree-service-categories/${id}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
};

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
